require('./_wks-define')('observable');



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/es7.symbol.observable.js
 ** module id = 2538
 ** module chunks = 0
 **/